(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-heading"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const DEBOUNCE_MS = 150;

    const debounce = (fn, wait) => {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn(...args), wait);
      };
    };

    const normalize = (s) =>
      (s || '')
        .toString()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .trim();

    const getProductGrid = () => document.querySelector('.product-grid, [class*="product-grid"]');

    const getCards = () => document.querySelectorAll('.product-grid__item, [data-product-id]');

    const getCardTitle = (card) => {
      const titleEl = card.querySelector('[class*="product-title"], .product-card__title, h3, h2, a');
      return normalize(titleEl?.textContent);
    };

    const applyFilter = (term) => {
      const cards = getCards();
      const needle = normalize(term);
      let visibleCount = 0;
      const newlyVisible = [];

      cards.forEach((card) => {
        if (!needle) {
          card.removeAttribute('data-search-hidden');
          visibleCount++;
          return;
        }
        const title = getCardTitle(card);
        if (title.includes(needle)) {
          if (card.hasAttribute('data-search-hidden')) newlyVisible.push(card);
          card.removeAttribute('data-search-hidden');
          visibleCount++;
        } else {
          card.setAttribute('data-search-hidden', '');
        }
      });

      updateEmptyState(needle, visibleCount, cards.length);

      // Cards that were previously hidden may have skipped lazy hydration —
      // nudge images to load eagerly so they render once visible again.
      newlyVisible.forEach((card) => {
        card.querySelectorAll('img[loading="lazy"]').forEach((img) => {
          img.loading = 'eager';
        });
      });
    };

    const getGridContainer = () => document.querySelector('results-list, .product-grid-container');

    const getEmptyHost = () =>
      document.querySelector('.product-grid') || getGridContainer();

    const updateEmptyState = (term, visibleCount) => {
      const host = getEmptyHost();
      if (!host) return;
      let empty = document.querySelector('[data-collection-search-empty]');
      if (term && visibleCount === 0) {
        if (!empty) {
          empty = document.createElement('div');
          empty.setAttribute('data-collection-search-empty', '');
          empty.className = 'collection-search-empty';
          host.appendChild(empty);
        } else if (empty.parentElement !== host) {
          host.appendChild(empty);
        }
        empty.textContent = 'Inga produkter matchar "' + term + '".';
      } else if (empty) {
        empty.remove();
      }
    };

    const init = (form) => {
      if (form.dataset.bound === '1') return;
      form.dataset.bound = '1';

      const input = form.querySelector('input[name="q"]');
      if (!input) return;

      const onInput = debounce((value) => {
        applyFilter(value);
      }, DEBOUNCE_MS);

      input.addEventListener('input', (event) => onInput(event.target.value));

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        applyFilter(input.value);
      });

      // Re-apply filter when new products are appended (infinite scroll).
      // Watch only the direct grid (results-list -> .product-grid) for added
      // top-level cards; deep subtree observation causes feedback loops with
      // lazy-hydrating <product-card> web components.
      const grid = getProductGrid();
      if (grid) {
        let scheduled = false;
        const observer = new MutationObserver((mutations) => {
          const hasAddedCards = mutations.some((m) =>
            Array.from(m.addedNodes).some(
              (n) => n.nodeType === 1 && (n.matches?.('.product-grid__item, [data-product-id]') || n.querySelector?.('.product-grid__item, [data-product-id]'))
            )
          );
          if (!hasAddedCards) return;
          if (scheduled) return;
          scheduled = true;
          requestAnimationFrame(() => {
            scheduled = false;
            if (input.value.trim()) applyFilter(input.value);
          });
        });
        observer.observe(grid, { childList: true });
      }
    };

    document.querySelectorAll('[data-collection-heading-search]').forEach(init);

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-collection-heading-search]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      const list = root.querySelector('[data-faq-list]');
      const button = root.querySelector('[data-faq-load-more]');
      if (!list || !button) return;

      button.addEventListener('click', function () {
        const hidden = list.querySelectorAll('[data-faq-extra][hidden]');
        hidden.forEach(function (el, index) {
          el.removeAttribute('hidden');
          el.style.animationDelay = index * 60 + 'ms';
          el.classList.add('is-revealing');
          el.addEventListener(
            'animationend',
            function () {
              el.classList.remove('is-revealing');
              el.style.animationDelay = '';
            },
            { once: true }
          );
        });

        const wrap = button.parentElement;
        wrap.classList.add('is-hiding');
        wrap.addEventListener(
          'animationend',
          function () {
            wrap.remove();
          },
          { once: true }
        );
      });
    }

    document.querySelectorAll('.faq').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["favoriter-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const update = (root, slides, fill) => {
      const max = slides.scrollWidth - slides.clientWidth;
      root.classList.toggle('favoriter-slider--no-overflow', max <= 1);
      if (!fill) return;
      const ratio = max > 0 ? slides.scrollLeft / max : 0;
      const scale = 0.25 + ratio * 0.75;
      fill.style.transform = `scaleX(${scale})`;
    };

    const init = (root) => {
      const slides = root.querySelector('slideshow-slides');
      const fill = root.querySelector('.favoriter-slider__progress-fill');
      if (!slides) return;
      update(root, slides, fill);
      slides.addEventListener('scroll', () => update(root, slides, fill), { passive: true });
      new ResizeObserver(() => update(root, slides, fill)).observe(slides);
    };

    document.querySelectorAll('.section-favoriter-slider').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-articles-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const update = (slides, fill) => {
      const max = slides.scrollWidth - slides.clientWidth;
      const ratio = max > 0 ? slides.scrollLeft / max : 0;
      const scale = 0.25 + ratio * 0.75;
      fill.style.transform = `scaleX(${scale})`;
    };

    const init = (root) => {
      const slides = root.querySelector('slideshow-slides');
      const fill = root.querySelector('.favoriter-slider__progress-fill');
      if (!slides || !fill) return;
      update(slides, fill);
      slides.addEventListener('scroll', () => update(slides, fill), { passive: true });
      window.addEventListener('resize', () => update(slides, fill));
    };

    document.querySelectorAll('.section-featured-articles-slider').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const update = (slides, fill) => {
      const max = slides.scrollWidth - slides.clientWidth;
      const ratio = max > 0 ? slides.scrollLeft / max : 0;
      const scale = 0.3 + ratio * 0.7;
      fill.style.transform = `scaleX(${scale})`;
    };

    const init = (root) => {
      const slides = root.querySelector('slideshow-slides');
      const fill = root.querySelector('.product-list__progress-fill');
      if (!slides || !fill) return;
      update(slides, fill);
      slides.addEventListener('scroll', () => update(slides, fill), { passive: true });
      window.addEventListener('resize', () => update(slides, fill));
    };

    document.querySelectorAll('.section-resource-list--with-sidebar').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();
})();
